export enum ConversationItemType {
  New = 'NEW',
  Task = 'TASK',
  Scheduled = 'SCHEDULED',
  Replied = 'REPLIED',
  Default = 'DEFAULT',
  Error = 'ERROR',
  Archived = 'ARCHIVED',
}
